<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <v-card class="lighten-4 mr-3 pa-3" dark color="rgba(29, 27, 65, 0.6)" style="height:100%;">
    <v-tabs v-model="tab" background-color="transparent" grow height="20">
      <v-tab class="caption">New Cases Trend</v-tab>
      <v-tab class="caption">Increasing Cases Alert</v-tab>
      <v-tab class="caption">Low Hospital Beds Alert</v-tab>
      <v-tab class="caption">High Cases of Population Alert</v-tab>
      <v-tab class="caption">Reporting Alerts</v-tab>
      <v-tabs-slider color="purple"></v-tabs-slider>
    </v-tabs>
    <v-tabs-items v-model="tab" class="transparent mt-3">
      <v-tab-item eager class="transparent">
        <NewCaseTrend ref="NewCaseTrend"></NewCaseTrend>
      </v-tab-item>
      <v-tab-item eager class="transparent">
        <IncreaseCaseTrend ref="IncreaseCaseTrend"></IncreaseCaseTrend>
      </v-tab-item>
      <v-tab-item eager class="transparent">
        <LowHospital ref="LowHospital"></LowHospital>
      </v-tab-item>
      <v-tab-item eager class="transparent">
        <HighestCasesPopulation ref="HighestCasesPopulation"></HighestCasesPopulation>
      </v-tab-item>
      <v-tab-item eager class="transparent">
        <LastReported ref="LastReported"></LastReported>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import NewCaseTrend from "@/components/africa/alerts/NewCaseTrend";
import IncreaseCaseTrend from "@/components/africa/alerts/IncreaseCaseTrend";
import LowHospital from "@/components/africa/alerts/LowHospital";
import HighestCasesPopulation from "@/components/africa/alerts/HighestCasesPopulation";
import LastReported from "@/components/africa/alerts/LastReported";

export default {
  name: "Alerts",
  components: {
    NewCaseTrend,
    IncreaseCaseTrend,
    LowHospital,
    HighestCasesPopulation,
    LastReported
  },
  data: () => ({
    tab: null
  }),
  watch: {
    tab: function (val) {
      var self = this

      switch(val) {
        case 0:
          if(this.$refs.NewCaseTrend) {
            setTimeout(function(){
              self.$refs.NewCaseTrend.resize()
            },2000)
          }
          break
      }

      //post the GA
      gtag("event", "alerts", {
        event_category: val,
        'send_to': 'UA-161523063-2'
      });

    }
  },
  methods: {
    loadCases(lastDate, data, countryDisplay) {

     //load the child components
     this.$refs.NewCaseTrend.loadCases(data, countryDisplay);
     this.$refs.IncreaseCaseTrend.loadCases(data, countryDisplay);
     this.$refs.LowHospital.loadCases(data, countryDisplay);
     this.$refs.HighestCasesPopulation.loadCases(data, countryDisplay);
     this.$refs.LastReported.loadCases(lastDate, data, countryDisplay);

    },
  },
};
</script>